/*
 * @title: 
 * @Author: wangshuai
 * @Date: 2024-08-28 09:57:43
 * @FilePath: \飞行-运营\src\api\model\navigationInput.js
 * @Description: 通航数据录入模块接口
 * 
 */
import config from "@/config";
import http from "@/utils/request";

export default {
	thAirport: {
		url: `${config.HNYJ_URL}/th/v1/thAirport`,
		name1: "通航机场-分页查询",
		get: async function (params) {
			return await http.get(this.url, params);
		},
		name2: "通航机场-新增",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		name3: "通航机场-修改",
		put: async function (data) {
			return await http.put(this.url, data);
		},
		name4: "通航机场-删除",
		delete: async function (params) {
			return await http.delete(this.url + params);
		},
	},
	thAirportById: {
		url: `${config.HNYJ_URL}/th/v1/thAirport/byId`,
		name1: "通航机场-通过ID查询单条数据",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	thAirspace: {
		url: `${config.NAIP_URL}/th/v1/thAirspace`,
		name1: "通航机场空域对象-分页查询",
		get: async function (params) {
			return await http.get(this.url, params);
		},
		name2: "通航机场空域对象-新增",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		name3: "通航机场空域对象-修改",
		put: async function (data) {
			return await http.put(this.url, data);
		},
		name4: "通航机场空域对象-删除",
		delete: async function (params) {
			return await http.delete(this.url + params);
		},
	},
	thAirspaceById: {
		url: `${config.NAIP_URL}/th/v1/thAirspace/byId`,
		name1: "通航机场空域对象-通过ID查询单条数据",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	pullDown: {
		url: `${config.MAIN_URL}/api/v1/airfield/runway/pullDown`,
		name1: "机场跑道查询",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
};